import { CentralSystem, LinkedCentralSystem } from '@infuse/e-connector/central-system/domain';
import { ChargingStation } from '@infuse/e-connector/charging-station/domain';

/**
 * By default, LinkedCentralSystem only contains IDs of the CentralSystem and ChargingStation.
 * This function hydrates the LinkedCentralSystems of a ChargingStation with the full CentralSystem and ChargingStation objects.
 *
 * This is done here to avoid circular dependencies between the store libraries (many-to-many relationship).
 *
 * @param chargingStation
 * @param centralSystems
 * @return An array of LinkedCentralSystemHydrated objects.
 */
export const hydrateLinkedCentralSystems = (
  chargingStation: ChargingStation,
  centralSystems: CentralSystem[]
): LinkedCentralSystemHydrated[] => {
  return chargingStation.linkedCentralSystems.map((lcs) => {
    const centralSystem = centralSystems.find((cs) => cs.id === lcs.centralSystemId);
    if (!centralSystem) {
      throw new Error(`Central system with ID ${lcs.centralSystemId} not found`);
    }
    return {
      ...lcs,
      chargingStation,
      centralSystem
    } as LinkedCentralSystemHydrated;
  });
};

export interface LinkedCentralSystemHydrated extends LinkedCentralSystem {
  centralSystem: CentralSystem;
  chargingStation: ChargingStation;
}
